import { useContext } from 'react'
import { ActivityTypesContext } from './context'

export function useActivityTypesContext() {
  const context = useContext(ActivityTypesContext)

  if (context === undefined)
    throw Error('Must be descendant of ActivityTypesContextProvider')

  return context
}
